import React, { FunctionComponent } from 'react';
import { Grid, Placeholder, Container, Message, Icon } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    padding: '4rem',
    margin: '12.5rem 0 4rem 0',
    backgroundColor: '#fff',
    borderRadius: '0.25em',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06);',
  },
  message: {
    backgroundColor: `#683caf1c !important`,
    color: `${theme.violet} !important`,
  },
});

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  message?: string;
};

const CSVPlaceholder: FunctionComponent<Props> = ({
  classes,
  message = 'We are fetching the CSV file for you.',
}) => (
  <Container className={classes.container}>
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <Placeholder>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <Placeholder>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <Placeholder>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <Placeholder>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <Message icon className={classes.message}>
            <Icon name="circle notched" loading />

            <Message.Content>
              <Message.Header>Just a few seconds</Message.Header>
              {message}
            </Message.Content>
          </Message>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
);

export default withStyles(styles)(CSVPlaceholder);
